import React from 'react';
import { Page, Link, Text, View, Document, Image, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    paddingLeft: 40,
    paddingRight: 40,
    paddingTop: 20,
    paddingBottom: 20,
  },
  section: {
    marginBottom: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: 'space-between',
  },
  companyName: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  companyAddress: {
    fontSize: 9,
    color: '#555555',
  },
  name: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  address: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  text: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  pageTitle: { fontSize: 12, fontWeight: 'bold', textAlign: 'center', width: '100%', textDecoration: 'underline' },
  textRow: { display: 'flex', flexDirection: 'row', alignItems: 'flex-start', position: 'relative', marginBottom: 10 },
  lCount: { fontWeight: 'bold', fontSize: 12, position: 'absolute' },
  para: { fontSize: 11, paddingLeft: 20, lineHeight: 1.2 },
  bold: { fontWeight: 'bold' },
});

const FixedFeePdf = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page} >
      <View style={styles.flexRow}>
        <View style={styles.companySection}>
          <Image
            style={{
              marginBottom: 10,
              width: '120px',
              alignSelf: 'flex-end',
            }}
            src="/logo192.png"
          />
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Text style={styles.companyName}>SKA NANKANA SAHIB SOLICITORS</Text>
          <Text style={styles.companyAddress}>
            101A Soho Hill, Hockley,
          </Text>
          <Text style={styles.companyAddress}>
            Birmingham, B19 1AY.
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(T):</Text> 0121 493 4730 | 0121 493 4731
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(Emergency Only):</Text> 07869 720 081 |
          </Text>
          <Text style={styles.companyAddress}>
            07861 460 640
          </Text>
          <Text style={styles.companyAddress}>
            <Text style={{ fontWeight: 'bold', marginRight: 3 }}>(E):</Text><Link href='mailto:office@skasolicitors.co.uk'>Office@SKASolicitors.co.uk</Link>
          </Text>
        </View>
      </View>

      <View style={[styles.flexRow, { marginTop: 20 }]}>
        <View>
          <View style={{ marginBottom: 10 }}>
            <View>
              <Text style={styles.name}>{data.title} {data.forename} {data.surname}</Text>
            </View>
            <View>
              {data.number_street ? <Text style={styles.address}>{data.number_street},</Text> : ""}
              {data.city ? <Text style={styles.address}>{data.city},</Text> : ""}
              {data.country ? <Text style={styles.address}>{data.country},</Text> : ""}
              {<Text style={styles.address}>{data.postal_code}</Text>}
            </View>
          </View>
        </View>
        <View style={[{ alignItems: 'flex-end' }]}>
          <View style={[styles.container, { marginBottom: 10 }]}>
            <Text style={styles.text}>File Ref Number: AA/SK/BHAM/{data.id}</Text>
          </View>
          <View style={styles.container}>
            <Text style={styles.text}>Date: {data.date}</Text>
          </View>
        </View>
      </View>
      <View style={[styles.flexRow, { marginTop: 5 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={styles.pageTitle}>TERMS OF BUSINESS: AGREED FIXED FEE CONTRACT AS MADE AND APPLIED</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>1.</Text>
            <Text style={styles.para}>This agreement is a confirmation of a legally binding contract as entered into between you and us. Please read carefully.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>2.</Text>
            <Text style={styles.para}>The agreement is entered into between you as named above and us <Text style={styles.bold}>“SKA NANKANA SAHIB
              SOLICITORS”</Text> authorised and regulated by Solicitors Regulation Authority SRA No: 659308, is a
              trading name of <Text style={styles.bold}>Thara Legal Ltd</Text>, registered in England and Wales, Companies House registration
              No: 11906084, whose registered office is at 144 Desborough Road, High Wycombe, England, United
              Kingdom.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>3.</Text>
            <Text style={styles.para}>The agreement relates to work we are to carry in connection with your matter as per your specific
              instructions and specific stage. It does not relate to any other or further work you might ask us to do
              and or incidentally becomes essential. An agreed fixed fee invoice is issued for this purpose. If
              further instructions are received a further invoice will be issued and these fixed fee arrangements
              may well continue to apply accordingly.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>4.</Text>
            <Text style={styles.para}>
              We have charged you this agreed fixed fee and you have been issued an invoice for this purpose
              after discussing all aspects of funding and your ability and willingness to pay us privately. This is
              unalterable and applies to both sides, whether the matter proceeds to desired completion or not.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>5.</Text>
            <Text style={styles.para}>
              We have advised you, for example other things that you may have to pay for.
            </Text>
          </View>

          <View style={styles.textRow}>
            <View style={styles.para}>
              <View style={{ display: 'flex', flexDirection: 'row', }}>
                <View style={{ display: 'flex', flexDirection: 'column', fontSize: 12, maxWidth: '45%', marginRight: '10%' }}>
                  <Text style={{ textDecoration: 'underline', fontWeight: 'bold', marginBottom: 5 }}>
                    Expenses
                  </Text>
                  <Text>
                    Home Office Fee, Court Fee etc. These fees may change. We will require you Pay the fee directly to recipient on the Day of your application is submitted. We do not hold any client money.
                  </Text>
                </View>
                <View style={{ display: 'flex', flexDirection: 'column', fontSize: 12, maxWidth: '45%' }}>
                  <Text style={{ textDecoration: 'underline', fontWeight: 'bold', marginBottom: 5 }}>
                    Cost (£) (approximately)
                  </Text>
                  <Text>
                    This is variable and you have
                    been advised. If in doubt, please
                    check now as we are not liable to
                    pay for your disbursements.
                  </Text>
                </View>
              </View>
            </View>
          </View>

          <View style={styles.textRow}>
            <View style={styles.para}>
              <Text style={[styles.lCount]}>Note:</Text>
              <Text style={[styles.para, { paddingLeft: 0 }]}>
                <Text>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Text>The above may be a non-exhaustive list. We endeavour to provide you with as much details
                as possible of all reasonably anticipated disbursements as appropriate. If other expenses are
                payable this would be informed to you promptly. We may have to pay fee from our office account if
                we are not holding any of your money in our client account and if you cannot be contacted quickly.
                This will become payable by you to us forthwith.
              </Text>
            </View>
          </View>

          <View style={styles.textRow}>
            <Text style={styles.lCount}>6.</Text>
            <Text style={styles.para}>
              Your total charges and expenses payable by you may therefore include our cost and any
              disbursements paid.
            </Text>
          </View>

          <View style={{ position: 'absolute', bottom: -100, left: 10, right: 10 }}>
            <View style={{ marginTop: 10, paddingTop: 5, textAlign: 'center' }}>
              <Text style={{ fontSize: 9, fontWeight: 'bold' }}>AUTHORISED AND REGULATED BY THE SOLICITORS REGULATION AUTHORITY: 659308</Text>
              <Text style={{ fontSize: 9, fontWeight: 'bold' }}>Mr. Arman Alam – Barrister at Law - Principal</Text>
              <Text style={{ fontSize: 6, fontStyle: 'italic' }}>SKA Nankana Sahib Solicitors is trading name of Thara Legal Ltd,, registered in England and Wales Companies House No: 11906084, whose registered office is at</Text>
              <Text style={{ fontSize: 7, fontStyle: 'italic' }}>144 Desborough Road, High Wycombe, England, United Kingdom</Text>
              <Text style={{ fontSize: 7 }}>We do not accept service of issues and documents by email and fax, all matters must be delivered by Royal Mail or Similar Services.</Text>
              <Text style={{ fontSize: 7 }}>We are committed to promoting equality and diversity and ensuring the security of your private personal information.</Text>
            </View>
          </View>


        </View>
      </View>

    </Page>
    <Page size="A4" style={styles.page} >
      <View style={[styles.flexRow, { marginTop: 40 }]}>
        <View style={styles.section}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>7.</Text>
            <Text style={styles.para}>If this firm does not complete the agreed work because of the withdrawal of your instructions, you
              will be liable to pay our agreed fixed costs. Likewise, our total charge will not exceed the fixed fee
              for this specific stage of the matter we have agreed to carry out, no matter, if we have to work more
              than what we envisaged at this moment, as long as it is within the exact scope of what is agreed e.g.
              a same second application to a department would be chargeable.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>8.</Text>
            <Text style={styles.para}>Agreed payment is due to us now on the commencement of your work or otherwise within 28 days
              of us issuing you the bill / invoice. This agreement is unalterable for the purpose of fee as all monies
              received will be placed in our office account.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>9.</Text>
            <Text style={styles.para}>The agreement is a non-contentious business agreement under Section 57 of the Solicitors Act
              1974. You will not be able to ask the Law Society to check the bill. You will have the right to get our
              bill reviewed by a court if you claim that the agreement as a whole is unfair or unreasonable.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>10.</Text>
            <Text style={styles.para}>
              We have begun work when you told us that you accept these terms but it is prudent for us to supply
              this in writing. By signing and returning to us the attached duplicate of the agreement you will help
              us in great deal. However, your instructions and our specific performance in accordance with and on
              your promise to honour the raised agreed fixed fee invoice in this matter amounts to an acceptance
              by you of these terms of Fixed Fee business under the general Law of Contract.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>11.</Text>
            <Text style={styles.para}>
              As discussed and agreed, your continuing instructions would be deemed of your acceptance of this
              agreement, irrespective of whether or not this document is signed and returned to us.
            </Text>
          </View>

          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0, paddingTop: 40 }]}>
              I accept the above terms.
            </Text>
          </View>

          <View style={{ display: 'flex', flexDirection: 'column', marginTop: 30 }}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              ......................................
            </Text>
            <Text style={[styles.para, { paddingLeft: 0 }]}>
              Your Signature
            </Text>
          </View>


        </View>
      </View>
    </Page>

    <Page size="A4" style={styles.page} >
      <View style={[styles.flexRow, { marginTop: 40 }]}>
        <View style={styles.section}>
          <View style={[styles.section, { marginBottom: 15 }]}>
            <Text style={[styles.pageTitle, { textAlign: 'left' }]}>TERMS AND CONDITIONS OF BUSINESS</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>We are providing you with a professional legal service with the utmost levels of care at our level best.</Text>
          </View>
          <View style={styles.textRow}>
            <Text style={[styles.para, { paddingLeft: 0 }]}>We aim to offer our clients quality legal advice with a personal service at a fair cost. Although we provide full information
              orally, we hope it is helpful to you to set out in this agreement the basis on which we will provide our professional
              services. Please discuss with us if you did not understand anything we have discussed or is written below.</Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>OUR COMMITMENT TO YOU</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0 }]}>We have as appropriate in contentious or non-contentious work, promised to</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              REPRESENT your interests and keep your instructions confidential and explained to you the legal work, which
              may be required, and the likely prospects of a successful outcome.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              KEEP you regularly informed of progress or, if there is none, when you are next likely to hear from us, in
              writing, by phone or text message or email in the manner best suits your understanding. We recommend that
              you phone us if 2 months are lapsed and you have not heard form us.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              TRY to avoid using technical legal language when writing to you – tell us when we fail in this aim.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              DEAL with your queries promptly, we will try to return your telephone calls on the same day; this may not be
              possible always. We request that you leave the exact name and reference of the file, your contact number
              and the reason of call with the call handler. If it is all ok on your matter, we may do other important works
              before we return your call, and shall endeavour to return your call as soon as practically possible.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>SERVICE COMMITMENT</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0 }]}>The service standards which we shall endeavour to adhere to and which we have agreed to are as follows:</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We shall endeavour to keep you regularly informed of any progress, we shall communicate in plain language,
              we shall explain to you the legal work that may be required. We shall further advise you regularly of the
              costs/risk benefit of pursuing the matter and of the likely timescale involved.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>RESPONSIBILITIES</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0 }]}>As explained our responsibilities to you are as follows:</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0, fontWeight: 'bold' }]}>We must:</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Always act in your best interests, subject to our duty to the court.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Explain to you the risks and benefits of taking legal action.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Give you our best advice about whether to accept any offer of settlement.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Give you the best information possible about the likely costs of your case.
            </Text>
          </View>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Represent you in the best possible professional manner.
            </Text>
          </View>
        </View>

        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0 }]}>Your responsibilities to us are as follows:</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={[styles.para, { paddingLeft: 0, fontWeight: 'bold' }]}>You must:</Text>
        </View>
      </View>

      <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Give us instructions that allow us to do our work properly.
          </Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&nbsp;</Text>
          <Text style={styles.para}>&nbsp;</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Not ask us to work in an improper or unreasonable way.
          </Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Not deliberately mislead us.
          </Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Co-operate with us.
          </Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Go to any medical or expert examination or court hearing.
          </Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.lCount}>&bull;</Text>
          <Text style={styles.para}>
            Fulfil the agreed cost implications promptly of our retainer.
          </Text>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>OUR HOURS OF BUSINESS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The normal hours of opening at our offices are between 9.00AM and 5.00PM weekdays. Messages can be
              left on the answerphone outside these hours and appointments can be arranged at other times when this is
              essential. Our out of hour’s emergency phone number is quoted on our letterhead covering this page.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>PEOPLE RESPONSIBLE FOR YOUR WORK</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The person responsible for supervising your work will be Mr. A. Alam a Barrister at Law. One of his legal team
              member and Secretary may be appointed to deal with your matter and who will be pleased to undertake day-
              to-day work on your matter. The member of legal team will always be a suitably qualified or experienced
              lawyer or appropriate advisor. We will try to avoid changing the people to handle your work but this cannot be
              avoided at times, the ultimate responsibility will remain with Mr. A. Alam. Please see specific client care letter
              sent to you detailing the name and status of the specific individual with day-to-day conduct of your matter.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The principal of this firm with final responsibility for work done is Mr. A. Alam.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>CHARGE AND EXPENSES (if appropriate see Fixed Fee arrangements letter)</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Our charges will be calculated mainly by reference to the time actually spent by the Solicitors and other staff
              in respect of any work that they do on your case. This will include meetings with you and other perhaps,
              reading and working on papers, correspondence including emails, preparation of the case and any detailed
              costs calculations, and time spent travelling away from the office when this is necessary. From time to time
              we may arrange for some of this work to be carried out by the person not directly employed by us. You will be
              charged at rates not greater than those set out below.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Routine letters are charged at 6 minutes unit of time and we charge for the time spent on making and taking
              telephone calls in 6-minute units and considering incoming letters at unit of 3 minute per page.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The current hourly rates are set out below. We will add VAT to these at the rate that applies when the work is
              done and the invoice is raised.
            </Text>
          </View>
        </View>
      </View>

      <View style={{ marginTop: 10, flexDirection: 'column' }}>
        <View style={{ display: 'flex', flexDirection: 'row', width: '90%', left: '5%', fontSize: 12 }}>
          <View style={{ border: '1px solid #000', width: '80%', padding: 2, paddingLeft: 5 }}>
            <Text>Principal</Text>
          </View>
          <View style={{ border: '1px solid #000', borderLeft: '0px', width: '20%', padding: 2, paddingLeft: 5 }}>
            <Text>£275.00</Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', width: '90%', left: '5%', fontSize: 12 }}>
          <View style={{ border: '1px solid #000', borderTop: '0px', width: '80%', padding: 2, paddingLeft: 5 }}>
            <Text>Partner Solicitors and Lawyers of other jurisdictions:</Text>
          </View>
          <View style={{ border: '1px solid #000', borderTop: '0px', borderLeft: '0px', width: '20%', padding: 2, paddingLeft: 5 }}>
            <Text>£200.00</Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'row', width: '90%', left: '5%', fontSize: 12 }}>
          <View style={{ border: '1px solid #000', borderTop: '0px', width: '80%', padding: 2, paddingLeft: 5 }}>
            <Text>Trainee Solicitors, Paralegals, under the supervision of the solicitors:</Text>
          </View>
          <View style={{ border: '1px solid #000', borderTop: '0px', borderLeft: '0px', width: '20%', padding: 2, paddingLeft: 5 }}>
            <Text>£275.00</Text>
          </View>
        </View>
      </View>

      <View style={[styles.section, { marginTop: 20 }]}>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              These hourly rates have to be reviewed periodically to reflect increases in overhead costs and inflation.
              Naturally the rates are reviewed with effect from 1st January each year. If a review is carried out before this
              matter has been concluded, we will inform you of any variation in the rate before it takes effect and applied to
              you.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Solicitors have to pay off various other expenses on behalf of clients ranging from Court fee, Home Office fee
              and so on. We have no obligation to make such payments unless you have provided us with the funds for that
              purpose. VAT is payable on certain expenses. We refer to such payments generally as disbursements. We
              will require a payment in advance from you in respect of any fees payable on your matter and it is very
              exceptionally and unlikely that we pay on your behalf.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              If, for any reason, this matter does not proceed to completion, we will be entitled to charge you for work done
              and expenses incurred, and a bill to this will be drawn up in accordance with these covered terms.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>PAYMENT ARRANGEMENTS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              It is normal practice to ask clients to pay sums of money from time to time on account of the charges and
              expenses, which are expected in the following weeks or months. We find that this helps clients in budgeting
              for costs as well as keeping them informed of legal expenses, which are being incurred. If such requests are
              not met with prompt payment, delay in the progress of a case may result. In the unlikely event of any bill or
              request for payment not being met, this firm must reserve the right to stop acting for you further, without
              incurring any liability for non-completion. So you must ensure yourself that you are able to pay.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Payment is due to us within 28 days of our sending you a bill. Interest will be charged on a daily basis at 4%
              over HSBC’s base rate from time to time from the date of the bill in cases where payment is not made within
              28 days of delivery by us of the bill.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The common law entitles us to retain any money, papers or other property belonging to you, which properly
              come into possession pending payment of our costs, whether or not the matter is completed in connection
              with the matter for which the costs were incurred. This is known as “general lien”. We are entitled to sell your
              belonging held under a lien but we are entitled to hold property, other than money, even if the value of it greatly
              exceeds the amount due to us in respect of costs (see below). We will not be liable for any damage to you
              due to us preserving our lieu for your non-compliance to the terms of the retainer.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>OTHER PARTIES CHARGES AND EXPENSES</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              In some cases and transactions, a client may be entitled to payment of costs by some other person. It is
              important that you understand that in such circumstances, the other person may not be required to pay all the
              charges and expenses, which you incur with us. You have to pay our charges and expenses in the first place
              and any amounts, which can be recovered, will be a contribution towards them. If the other party is in receipt
              of legal aid no costs are likely to be recovered.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The other person will not be liable to pay VAT element of your costs if you are able to recover the VAT yourself.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              If you are successful and court orders another party to pay some or all of your charges and expenses, interest
              can be claimed on them from the other party from the date of the court order. We will account to you for such
              interest to the extent that you have paid our charges and expenses on account, but we are entitled to the rest
              of that interest.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              You will also be responsible for paying our charges and expenses of seeking to recover any costs that the
              court orders the other party to pay to you.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              A client who is unsuccessful in a court case may be ordered to pay other party’s legal charges and expenses.
              That money would be payable in addition to our charges and expenses. Arrangements can be made to take
              out insurance to cover liability for such legal expenses. Please discuss with us if you are interested in this
              possibility, we are not automatically bound to purchase this for you and acceptance of this by insurer depends
              on the strength of your case.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>STORAGE OF PAPERS AND DOCUMENTS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              After completing the work we are entitled to keep all the papers and documents while there is money owing to
              us for our charges and expenses. In addition, we will keep your file of papers for you in storage for not less
              than 1 year. After that storage is on the clear understanding that we have the right to destroy it after such
              period, as we consider reasonable or to make a charge for storage if we ask to collect your papers and you
              fail to do so. We will not of course destroy any documents such as old passports, nationality or right of abode
              documents, Will, Deeds and other securities, which you ask us to hold in safe custody. No charge will be
              made to you for such storage unless prior notice in writing is given to you of a charge to be made from a future
              date that may be specified in that notice.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              If we retrieve papers and documents from storage in relation to continuing or new instructions to act in
              connection with your affairs, we will not normally charge for such retrieval but at times it may apply. We may
              make a charge based on time spent for providing stored papers or documents to you or another at your
              request. We may charge for reading, correspondence or other work such as photocopying, postage etc.
              necessary to comply with instructions.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>INSURANCE CONTRACTS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We are not authorised by the Financial Services Authority and we do not offer any financial and investment
              advice and assistance.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>EXEMPT REGULATED ACTIVITIES AND INSURANCE MEDIATION</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We do not undertake any of these activities, however sometimes e.g. family work involves investments. We
              are not authorised by the Financial Services Authority and so may refer you to someone who is authorised to
              provide any necessary advice. However, we can provide certain limited services in relation to investments,
              provided they are closely linked with the legal services we are providing to you, as we are regulated by the
              Solicitors Regulation Authority.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>COMPLAINTS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              If you have any problem with the services we have provided for you then please let us know. We will try to
              resolve any problem quickly and operate an internal complaints handling system to help us resolve the problem
              between ourselves. If for any reason we are unable to resolve the problem between us, then we are regulated
              by the Solicitors Regulation Authority and complaints and redress mechanisms are provided through the
              Solicitors Regulation Authority and the Legal Ombudsman. Copy of complaints procedure can be requested
              at any time. If you have a complaint, please give the details (by letter, email or telephone) to the Case Worker
              with who is dealing with your matter. If you are still not satisfied with the response, then please write to Mr. A
              ALAM, who is the compliance partner at this practice. The envelope should be marked “PRIVATE AND
              CONFIDENTIAL”. He will then investigate your complaint and write to you
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The Law Society is a designated professional body for the purposes of the Financial Services and Markets Act
              2000, but responsibility for regulation and complaints handling has been separated from the Law Society’s
              representative functions. The Solicitors Regulation Authority is the independent regulatory body of the Law
              Society and the Legal Ombudsman is the independent complaints handling body for the Law Society.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>TERMINATION & LIEN</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              You may terminate your instructions to us in writing at any time but we will be entitled to keep all your papers
              and documents while there is money owing to us for our charges and expenses. If at any stage you do not
              wish us to continue doing work and/ or incurring charges and expenses on your behalf, you must tell us this
              clearly in writing. (Please also refer to Fixed Fee Agreement).
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              If we decide to stop acting for you, for example if you do not pay an interim bill or comply with the request for
              payment on account, we will tell you the reason and give you notice in writing.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              You can end this agreement and instructions at any time as above. We can also end this agreement if you do
              not keep to your responsibilities.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              After this agreement ends, we may have our name removed from the record of any Court proceedings in which
              we are acting.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&nbsp;</Text>
            <Text style={styles.para}>
              &nbsp;
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We have the right to preserve our lien unless another solicitor working for you undertakes to pay us what we
              are owed.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              This means we have a right to keep all papers, documents, money or other property held on your behalf until
              all money due to us is paid.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              A lien may be applied after this agreement ends.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>LIMITED COMPANIES</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              When accepting instructions to act on behalf of a limited company, we may require a Director and/or controlling
              shareholder to sign a form of personal guarantee in respect of the charges and expenses of this firm. If such
              a request is refused, we will be entitled to stop acting and to require immediate payment of our charges on an
              hourly basis and expenses as set out earlier.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>IDENTITY AND DISCLOSURE REQUIREMENTS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We are entitled to refuse to act for you if you fail to supply appropriate proof of identity for yourself or for any
              person whom you may represent/ sponsor.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We will not be liable for any loss, damage or delay arising out of the firm’s compliance with any Statutory or
              Regulatory requirements.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>COMMUNICATION BETWEEN YOU AND US</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Our aim is to offer all our clients an efficient and effective service at all times. Our clients and our staff are of
              first importance to us. We hope that you will be pleased with the work we do for you. However, should there
              be any aspect of our service with which you are unhappy, please raise your concern in the first place with Mr.
              A. Alam’s assistant delegated with your day-to-day work. If you still have queries or concerns, please contactour Clients Care Services. Mr. A. Alam is also the Client Care Supervisor to whom any final difficulty can be
              reported.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              We will aim to communicate with you by such a method as you may request. We may not be able to keep
              record of phone calls or text message at times sent to you with the aim of keeping you abreast with the
              development on your matter. If you prefer, we will always inform you in writing. Unless you withdraw consent,
              we will communicate with others when appropriate by email or fax but we cannot be responsible for the security
              of correspondence and documents sent by email or fax.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              The Data Protection Act requires us to advise you that your particulars are held on our data/information
              records. We may, from time to time, use these details to send you information, which we think, might be of
              interest to you.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Certain matters related with government departments can take longer than expected. Please phone us if you
              have not heard from us for more than three months, while we would endeavour to do so always, at times we
              may only send a reminder to e.g. Home Office and send you a copy of it or a simple text informing you, we
              may simply forward you a copy of correspondence received from Home Office depending on our professional
              judgement. In certain circumstances we will not need further instructions from you, it may be a simple
              repetition, we would respond accordingly to other sides as previously advised focusing on the planned
              outcome.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>TERMS AND CONDITIONS OF BUSINESS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Unless otherwise agreed, and subject to the application of the then ‘current’ hourly rates, these Terms and
              Conditions of Business shall also apply to any future instructions for next stages or for separate matter given
              by you to this firm.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              Your continuing instructions and or our continuous work in this particular matter will amount to an acceptance
              of these Terms and Conditions of Business.
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&nbsp;</Text>
            <Text style={styles.para}>
              &nbsp;
            </Text>
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              A file opening standard client care letter is also issued to you, it may not be possible to put full details of your
              instruction in the same but these are surely establish-able from the work we carry out for you on the basis of
              your continuing instructions.
            </Text>
          </View>
        </View>
      </View>

      <View style={styles.section}>
        <View style={[styles.section, { marginBottom: 15 }]}>
          <Text style={[styles.pageTitle, { textAlign: 'left' }]}>COSTS ESTIMATE AND TIME ESTIMATE AND EXPECTATIONS</Text>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', margin: 0, padding: 0, gap: 0 }}>
          <View style={styles.textRow}>
            <Text style={styles.lCount}>&bull;</Text>
            <Text style={styles.para}>
              These have not been included within these Terms of Business, these can vary, and you must have been given
              this information in the meeting with us, sometimes we are sure and sometimes we only act upon your
              instructions where matters are 50-50%, a specific client care letter depending on the urgency of the instructions
              received may include these. If you are not clear and require any further information in this regard, we shall be
              happy to provide further details in writing on request. Our prediction on the basis of our experience could go
              wrong outcome, estimated time, expectations and cost at times, though we do our best in giving you the
              likelihood. The agreed fixed fee rules however differ and a separate informative term of business, client care
              is issued. Where you have been advised a matter has 50% or below chance of success if we continue to act,
              then we do so, in accordance with your express instructions.
            </Text>
          </View>
        </View>
      </View>

    </Page>
  </Document >
);

export default FixedFeePdf;
